import { Sheets } from "../components/Sheets";

export function DocumentsPage() {
  return (
    <>
      <h1>Шаблоны документов</h1>
      <p className="lead">Образцы практикующего адвоката. Выберите документ — помощник задаст вопросы в чате и соберёт файл Word.</p>
      <div className="sheets"><Sheets /></div>
    </>
  );
}
